// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__5F0fC"};